import React from 'react';

import AppearTransition from '../lib/AppearTransition';
import AppLinks from '../lib/AppLinks';

import avatar from '../imgs/avatar.svg';
import check from '../imgs/check-circle.svg';

// preload svgs
[avatar, check].forEach(function(src) {
  const img = new Image();
  img.src = src;
});

export default function Verified({title, message}) {
  return <div className="App-Card animated">
    <AppearTransition animation="zoomIn">
      <div className="animated App-Card-decoration">
        <img className="App-Card-avatar" src={avatar} alt="Smiley face" />
        <img className="App-Card-check" src={check} alt="" />
      </div>
    </AppearTransition>

    <h1 className="App-Card-title">{title}</h1>
    <p className="App-Card-message">{message}</p>

    <AppLinks />
  </div>
}



// WEBPACK FOOTER //
// ./src/lib/Success.js